import { storage } from "@app/scripts/storage"
import config from "@app/config";

export const useStorage = () => {
    const shop = Shopify?.shop?.split(".myshopify")[0];
    const storeConfig = config?.stores[shop];
    const storeId = storeConfig?.shopify_domain

    const getStorage = (key: string) => storage.get(`${storeId}:${key}`)

    const setStorage = (key: string, value: any, expiryDays?: number) => storage.set(`${storeId}:${key}`, value, expiryDays || undefined)

    const removeStorage = (key: string) => storage.remove(`${storeId}:${key}`)

    return { getStorage, setStorage, removeStorage }
}
